import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/**
 * Estado controlado da sidebar do AppShell (@miror/ui-web). O shared é
 * puramente controlado — collapse e expansão de seções moram aqui e
 * persistem em localStorage.
 */
interface SidebarState {
  collapsed: boolean;
  expandedSections: Record<string, boolean>;
  toggle: () => void;
  toggleSection: (key: string) => void;
}

export const useSidebar = create<SidebarState>()(
  persist(
    (set) => ({
      collapsed: false,
      expandedSections: {},
      toggle: () => set((s) => ({ collapsed: !s.collapsed })),
      toggleSection: (key) =>
        set((s) => ({
          expandedSections: { ...s.expandedSections, [key]: !s.expandedSections[key] },
        })),
    }),
    { name: 'mirortask.sidebar' },
  ),
);
